<template>
    <span class="text-nowrap" v-if="user">
        <!-- User Avatar und Name -->
        <span v-if="showUser"
              class="ps-1 ps-md-0 align-middle"
              :class="{'text-sakali-primary':highlight, 'font-italic': user.cpu}">
      <cld-image
              :publicId="avatarId"
              :width="size"
              :height="size"
              crop="fill"
              radius="max"
              class="d-inline-flex">
      </cld-image>
            {{ user.name }}
        </span>

        <!-- vereinslos -->
        <span class="text-nowrap" v-if="showTeam && !user.team">
            vereinslos
        </span>
        <!-- Team Emblem und Name -->
        <span v-if="showTeam && user.team">
            <team-emblem :size="size" :emblem-id="user.team.emblemId"/>
            <span class="ps-1 align-middle"
                  :class="{'text-sakali-highlight':highlight}">
                {{ user.team.name }}
            </span>
        </span>
    </span>
</template>

<script>
export default {
    props: {
        user: Object,
        small: {
            type: Boolean,
            default: true
        },
        highlight: Boolean,
        showUser: {
            type: Boolean,
            default: true
        },
        showTeam: {
            type: Boolean,
            default: false
        },
        showAvatar: {
            type: Boolean,
            default: true
        }
    },
    computed: {
        dimension() {
            return this.size + 'px'
        },
        size() {
            return (this.small ? '21' : '32')
        },
        avatarId() {
            if (this.user) {
                return 'sandkastenliga/avatars/' + this.user.avatarId
            }
            return 'default-avatar'
        }
    }
}
</script>
